import { useState, useRef, useCallback, useEffect } from "react";
function useDetails(eventHandlers = {}) {
  const [isOpen, setIsOpen] = useState(false);
  const ref = useRef(null);
  const eventHandlersRef = useRef(eventHandlers);
  eventHandlersRef.current = eventHandlers;
  const handleOutsideClick = useCallback((event) => {
    var _a, _b, _c;
    if (event.target instanceof Node && !((_a = ref.current) == null ? void 0 : _a.contains(event.target))) {
      setIsOpen(false);
      document.removeEventListener("click", handleOutsideClick);
      (_c = (_b = eventHandlersRef.current).onClose) == null ? void 0 : _c.call(_b);
    }
  }, []);
  const handleSummaryClick = (event) => {
    var _a, _b, _c, _d;
    event.preventDefault();
    if (isOpen) {
      setIsOpen(false);
      document.removeEventListener("click", handleOutsideClick);
      (_b = (_a = eventHandlersRef.current).onClose) == null ? void 0 : _b.call(_a);
    } else {
      setIsOpen(true);
      document.addEventListener("click", handleOutsideClick);
      (_d = (_c = eventHandlersRef.current).onOpen) == null ? void 0 : _d.call(_c);
    }
  };
  useEffect(() => {
    return () => document.removeEventListener("click", handleOutsideClick);
  }, [handleOutsideClick]);
  return { ref, isOpen, handleSummaryClick };
}
export {
  useDetails
};
